import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "collapse show" }
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "row mb-6" }
const _hoisted_8 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_9 = { class: "col-lg-8 fv-row" }
const _hoisted_10 = { class: "fv-plugins-message-container" }
const _hoisted_11 = { class: "fv-help-block" }
const _hoisted_12 = { class: "row mb-6" }
const _hoisted_13 = { class: "col-lg-4 required col-form-label fw-bold fs-6" }
const _hoisted_14 = { class: "col-lg-8 fv-row" }
const _hoisted_15 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_16 = { class: "fv-help-block" }
const _hoisted_17 = { class: "row mb-6" }
const _hoisted_18 = { class: "col-lg-4 required col-form-label fw-bold fs-6" }
const _hoisted_19 = { class: "col-lg-8 fv-row" }
const _hoisted_20 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_21 = { class: "fv-help-block" }
const _hoisted_22 = { class: "row mb-6" }
const _hoisted_23 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_24 = { class: "col-lg-8 fv-row" }
const _hoisted_25 = { class: "row mb-6" }
const _hoisted_26 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_27 = { class: "col-lg-8 fv-row" }
const _hoisted_28 = { class: "fv-plugins-message-container" }
const _hoisted_29 = { class: "fv-help-block" }
const _hoisted_30 = { class: "row mb-6" }
const _hoisted_31 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_32 = { class: "col-lg-8 fv-row" }
const _hoisted_33 = { class: "fv-plugins-message-container" }
const _hoisted_34 = { class: "fv-help-block" }
const _hoisted_35 = { class: "row mb-6" }
const _hoisted_36 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_37 = { class: "col-lg-8 fv-row" }
const _hoisted_38 = { class: "row mb-6" }
const _hoisted_39 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_40 = { class: "col-lg-8 fv-row" }
const _hoisted_41 = { class: "fv-plugins-message-container" }
const _hoisted_42 = { class: "fv-help-block" }
const _hoisted_43 = { class: "row mb-6" }
const _hoisted_44 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_45 = { class: "col-lg-8 fv-row" }
const _hoisted_46 = { class: "row mb-6" }
const _hoisted_47 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_48 = { class: "col-lg-8 fv-row" }
const _hoisted_49 = { class: "row mb-6" }
const _hoisted_50 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_51 = { class: "col-lg-8 fv-row" }
const _hoisted_52 = { class: "row mb-6" }
const _hoisted_53 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_54 = { class: "col-lg-8 fv-row" }
const _hoisted_55 = {
  disabled: "",
  selected: "",
  value: "0"
}
const _hoisted_56 = ["value"]
const _hoisted_57 = { class: "row mb-6" }
const _hoisted_58 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_59 = { class: "col-lg-8 fv-row" }
const _hoisted_60 = { class: "row mb-6" }
const _hoisted_61 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_62 = { class: "col-lg-8 fv-row" }
const _hoisted_63 = { class: "row mb-6" }
const _hoisted_64 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_65 = { class: "col-lg-8 fv-row" }
const _hoisted_66 = ["value", "selected"]
const _hoisted_67 = { class: "fv-plugins-message-container" }
const _hoisted_68 = { class: "fv-help-block" }
const _hoisted_69 = {
  key: 0,
  class: "row mb-6"
}
const _hoisted_70 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_71 = { class: "col-lg-8 fv-row" }
const _hoisted_72 = ["value"]
const _hoisted_73 = {
  key: 1,
  class: "card-footer d-flex justify-content-end py-6 px-9"
}
const _hoisted_74 = { class: "indicator-label" }
const _hoisted_75 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_76 = {
  key: 0,
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_77 = { class: "indicator-label" }
const _hoisted_78 = { class: "indicator-progress" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.can('read', 'registered-trades'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('updateRegisteredTrades')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Form, {
            class: "form",
            onSubmit: _ctx.onSubmitUpdate,
            "validation-schema": _ctx.registeredTradeSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.translate('transactionDate')) + ": ", 1),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_Field, {
                      type: "date",
                      name: "transactionDate",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      modelValue: _ctx.registeredTrade.transactionDate,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.registeredTrade.transactionDate) = $event))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_ErrorMessage, { name: "transactionDate" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("label", _hoisted_13, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.translate('areas')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_Multiselect, {
                      modelValue: _ctx.registeredTrade.areaId,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.registeredTrade.areaId) = $event)),
                      required: true,
                      label: "titleAr",
                      trackBy: "titleAr",
                      searchable: true,
                      canDeselect: false,
                      options: _ctx.areas,
                      placeholder: _ctx.translate('selectAreas'),
                      valueProp: "id",
                      noResultsText: _ctx.translate('noResultsFound'),
                      name: "selectedArea"
                    }, null, 8, ["modelValue", "options", "placeholder", "noResultsText"]),
                    (_ctx.registeredTrade.areaId == 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.translate('AREA_IS_REQUIRED_FIELD')), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("label", _hoisted_18, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.translate('propertyType')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_Multiselect, {
                      modelValue: _ctx.registeredTrade.propertyTypeId,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.registeredTrade.propertyTypeId) = $event)),
                      required: true,
                      label: "titleAr",
                      trackBy: "titleAr",
                      searchable: true,
                      canDeselect: false,
                      options: _ctx.propertyTypes,
                      placeholder: _ctx.translate('selectPropertyType'),
                      valueProp: "id",
                      noResultsText: _ctx.translate('noResultsFound'),
                      name: "selectedPropertyType"
                    }, null, 8, ["modelValue", "options", "placeholder", "noResultsText"]),
                    (_ctx.registeredTrade.propertyTypeId == 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.translate('PROPERTY_TYPE_IS_REQUIRED_FIELD')), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.translate('block')), 1),
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "block",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('block'),
                      modelValue: _ctx.registeredTrade.block,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.registeredTrade.block) = $event))
                    }, null, 8, ["placeholder", "modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.translate('size')), 1),
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(_component_Field, {
                      type: "number",
                      name: "size",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('size'),
                      onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.updatePricePerSqrM())),
                      modelValue: _ctx.registeredTrade.size,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.registeredTrade.size) = $event)),
                      style: {"color":"#0066ff !important","font-weight":"bold"}
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _createVNode(_component_ErrorMessage, { name: "size" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.translate('price')), 1),
                  _createElementVNode("div", _hoisted_32, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "price",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('price'),
                      onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.updatePricePerSqrM())),
                      modelValue: _ctx.formattedPrice,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formattedPrice) = $event)),
                      style: {"color":"red !important","font-weight":"bold"}
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        _createVNode(_component_ErrorMessage, { name: "price" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.translate('percentage')), 1),
                  _createElementVNode("div", _hoisted_37, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "percentage",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('percentage'),
                      modelValue: _ctx.registeredTrade.percentage,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.registeredTrade.percentage) = $event))
                    }, null, 8, ["placeholder", "modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("label", _hoisted_39, _toDisplayString(_ctx.translate('pricePerM2')), 1),
                  _createElementVNode("div", _hoisted_40, [
                    _createVNode(_component_Field, {
                      type: "number",
                      name: "pricePerM2",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('pricePerM2'),
                      modelValue: _ctx.registeredTrade.pricePerM2,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.registeredTrade.pricePerM2) = $event))
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("div", _hoisted_42, [
                        _createVNode(_component_ErrorMessage, { name: "pricePerM2" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.translate('description')), 1),
                  _createElementVNode("div", _hoisted_45, [
                    _createVNode(_component_Multiselect, {
                      modelValue: _ctx.registeredTrade.descriptionId,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.registeredTrade.descriptionId) = $event)),
                      options: _ctx.registeredDescs,
                      label: "titleAr",
                      trackBy: "titleAr",
                      searchable: true,
                      canDeselect: false,
                      valueProp: "id",
                      placeholder: _ctx.translate('selectDescription'),
                      noResultsText: _ctx.translate('noResultsFound'),
                      name: "description",
                      onChange: _ctx.updateDesc
                    }, null, 8, ["modelValue", "options", "placeholder", "noResultsText", "onChange"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("label", _hoisted_47, _toDisplayString(_ctx.translate('descriptionAr')), 1),
                  _createElementVNode("div", _hoisted_48, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "descriptionAr",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('descriptionAr'),
                      modelValue: _ctx.registeredTrade.descriptionAr,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.registeredTrade.descriptionAr) = $event))
                    }, null, 8, ["placeholder", "modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("label", _hoisted_50, _toDisplayString(_ctx.translate('descriptionEn')), 1),
                  _createElementVNode("div", _hoisted_51, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "descriptionEn",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('descriptionEn'),
                      modelValue: _ctx.registeredTrade.descriptionEn,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.registeredTrade.descriptionEn) = $event))
                    }, null, 8, ["placeholder", "modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("label", _hoisted_53, _toDisplayString(_ctx.translate('notes')), 1),
                  _createElementVNode("div", _hoisted_54, [
                    _createVNode(_component_Field, {
                      as: "select",
                      name: "notes",
                      class: "form-select form-select-solid form-select-lg text-capitalize",
                      onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.updateNotes($event.target.value)))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("option", _hoisted_55, _toDisplayString(_ctx.translate('selectNotes')), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.registeredNotes, (registeredNote) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: registeredNote.id,
                            value: registeredNote['id']
                          }, _toDisplayString(registeredNote['titleAr']), 9, _hoisted_56))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("label", _hoisted_58, _toDisplayString(_ctx.translate('notesAr')), 1),
                  _createElementVNode("div", _hoisted_59, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "notesAr",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('notesAr'),
                      modelValue: _ctx.registeredTrade.notesAr,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.registeredTrade.notesAr) = $event))
                    }, null, 8, ["placeholder", "modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("label", _hoisted_61, _toDisplayString(_ctx.translate('notesEn')), 1),
                  _createElementVNode("div", _hoisted_62, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "notesEn",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('notesEn'),
                      modelValue: _ctx.registeredTrade.notesEn,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.registeredTrade.notesEn) = $event))
                    }, null, 8, ["placeholder", "modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("label", _hoisted_64, _toDisplayString(_ctx.translate('status')), 1),
                  _createElementVNode("div", _hoisted_65, [
                    _createVNode(_component_Field, {
                      as: "select",
                      name: "status",
                      class: "form-select form-select-solid form-select-lg",
                      modelValue: _ctx.registeredTrade.status,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.registeredTrade.status) = $event)),
                      onChange: _ctx.onStatusChange
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusMap, (value, key) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: value,
                            value: value,
                            selected: value === 1
                          }, _toDisplayString(key), 9, _hoisted_66))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"]),
                    _createElementVNode("div", _hoisted_67, [
                      _createElementVNode("div", _hoisted_68, [
                        _createVNode(_component_ErrorMessage, { name: "status" })
                      ])
                    ])
                  ])
                ]),
                (_ctx.registeredTrade.status !== 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                      _createElementVNode("label", _hoisted_70, _toDisplayString(_ctx.translate('statusNotes')), 1),
                      _createElementVNode("div", _hoisted_71, [
                        _createVNode(_component_Field, {
                          as: "select",
                          name: "statusNotesId",
                          class: "form-select form-select-solid form-select-lg",
                          modelValue: _ctx.registeredTrade.statusNotesId,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.registeredTrade.statusNotesId) = $event))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusNoteMap, (value, key) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: value,
                                value: value
                              }, _toDisplayString(key), 9, _hoisted_72))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.registeredTrade.status === 5)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-primary",
                        ref: "submitButtonBlock",
                        onClick: _cache[18] || (_cache[18] = _withModifiers(($event: any) => (_ctx.showBlocksList(_ctx.registeredTrade.id)), ["prevent"]))
                      }, [
                        _createElementVNode("span", _hoisted_74, _toDisplayString(_ctx.translate('showBlocksListing')), 1)
                      ], 512)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_75, [
                _createElementVNode("button", {
                  type: "reset",
                  class: "btn btn-white btn-active-light-primary me-2",
                  onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                }, _toDisplayString(_ctx.translate('discard')), 1),
                (_ctx.can('update', 'registered-trades'))
                  ? (_openBlock(), _createElementBlock("button", _hoisted_76, [
                      _createElementVNode("span", _hoisted_77, _toDisplayString(_ctx.translate('saveChanges')), 1),
                      _createElementVNode("span", _hoisted_78, [
                        _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                        _hoisted_79
                      ])
                    ], 512))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ]))
    : _createCommentVNode("", true)
}